import React, { Fragment } from 'react';
import { List, ListItem, ListItemText, Grid, CircularProgress } from '@material-ui/core';

export const LoadingProgress = (props) => {
  const { data } = props;
  
  return (
    <Fragment>
      {data.length < 1
        ? 
        <Grid container justify='center' alignContent='center' style={{paddingTop: 20}}>
          <Grid item>
            <CircularProgress />
          </Grid>
        </Grid>
        : 
        data[0].noItems
        ? <List><ListItem key={0}><ListItemText primary={data[0].noItems} /></ListItem></List>
        : props.children
      }
    </Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/components/containers/LoadingProgress.js